import { shallowEqual, useSelector } from 'react-redux';

import { ChangePostcode } from 'components/common/change-postcode/ChangePostcode';
import { useMaskPII } from 'hooks/useMaskPII';
import { selectedAddress } from 'state/selected-address/selected-address-slice';
import { getPostcodeFormat } from 'utils/getPostcodeFormat';

type ChangeAddressProps = {
  handleGoBack?: () => void;
};

export const ChangeAddress = ({ handleGoBack }: ChangeAddressProps) => {
  const { displayName, postcode } =
    useSelector(selectedAddress, shallowEqual) || {};
  const { mask } = useMaskPII();

  return (
    <div>
      <span {...mask}>{displayName}, </span>
      <ChangePostcode
        postcode={getPostcodeFormat(postcode)}
        handleGoBack={handleGoBack}
        ctaLabel="Change address"
      />
    </div>
  );
}
